<template>
  <div>
    <!-- 新增按钮 -->
    <Button type="primary" @click="openAddModal">新增</Button>

    <Input
      v-model="searchId"
      placeholder="输入商品ID"
      style="width: 200px; margin-right: 10px"
    />
    <Input
      v-model="searchName"
      placeholder="输入商品名称"
      style="width: 200px; margin-right: 10px"
    />
    <Select
      v-model="searchType"
      placeholder="请选择商品分类"
      style="width: 200px; margin-right: 10px"
    >
      <Option value="">未选择</Option>
      <Option
        v-for="item in goodstypeOptions"
        :value="item.value"
        :key="item.value"
        >{{ item.label }}</Option
      >
    </Select>
    <Select
      v-model="searchStatus"
      placeholder="请选择商品状态"
      style="width: 200px; margin-right: 10px"
    >
      <Option value="">全部</Option>
      <Option value="1">在售</Option>
      <Option value="0">下架</Option>
    </Select>
    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="10"
          @on-change="changePage"
        ></Page>
      </div>
    </div>
    <!-- 新增商品的模态框 -->
    <Modal v-model="modal1" width="360">
      <div style="text-align: center">
        <Form
          :label-width="120"
          ref="formData"
          :model="formData"
          :rules="rules"
        >
          <!-- 商品名称 -->
          <FormItem label="商品id" prop="goodsid">
            <Input
              placeholder="请输入商品id"
              v-model="formData.goodsid"
            ></Input>
            <Button type="primary" size="small" @click="openGoodsSearchModal" style="margin-left: 5px;">查询商品</Button>
          </FormItem>

          <!-- 商品成本价 -->
          <FormItem label="商品兑换碎片" prop="exintegral">
            <Input
              placeholder="请输入商碎片"
              v-model="formData.exintegral"
            ></Input>
          </FormItem>

          <FormItem label="商品兑换等级" prop="user_level">
            <Input
              placeholder="请输入商品兑换所需碎片"
              v-model="formData.user_level"
            ></Input>
          </FormItem>

          <!-- 分解成金币 -->
          <FormItem label="允许兑换数量" prop="goodsnum">
            <Input
              placeholder="请输入允许兑换数量"
              v-model="formData.goodsnum"
            ></Input>
          </FormItem>
        </Form>
      </div>

      <div slot="footer">
        <Button type="primary" @click="handleSubmit">提交</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </Modal>
    <Modal v-model="modal2" title="增加商品数量" width="300">
      <div>
        <Input
          v-model="newGoodsNum"
          placeholder="请输入增加商品数量"
          :min="1"
          style="width: 200px"
          @on-input="validatePositiveInteger"
        />
        <div>
          增加后:{{
            parseInt(selgoodsnum) +
            (isNaN(parseInt(newGoodsNum, 10)) ? 0 : parseInt(newGoodsNum))
          }}
        </div>
      </div>
      <div slot="footer">
        <Button @click="submitGoodsNum">确认修改</Button>
        <Button @click="cancelGoodsNum">取消</Button>
      </div>
    </Modal>
    <exchangeListModal
      :visible="modal3"
      :user_id="clickgoodsid"
      @guanbimodal="guanbimodal"
    />
    <GoodsSearchModal
      :visible.sync="goodsSearchModal"
      :goodstypeOptions="goodstypeOptions"
      @select-goods="selectGoods"
    />
  </div>
</template>

<script>
import SingleUpload from "@/components/Upload/singleUpload";
import exchangeListModal from "./exchangeListModal.vue"; // 引入刚刚创建的封号组件
import GoodsSearchModal from "@/components/GoodsSearchModal.vue";
import { formatOssUrl } from "@/utils";

import {
  cmsAddgoods,
  cmsSelShop,
  updateShopStatus,
  cmsUpdateGoodsNum,
} from "../../api/shop";

// 导入商品相关API
import { cmsSelgoods } from "../../api/product";

export default {
  components: { SingleUpload, exchangeListModal, GoodsSearchModal },
  data() {
    return {
      goodstypeOptions: this.$goodsTypeOptions,
      modal1: false,
      modal2: false,
      loading: false,
      clickgoodsid: "",
      newGoodsNum: "",
      modal3: false,
      beizhu: "",
      isEdit: false,
      formData: {
        goodsid: "",
        goodsnum: "",
        exintegral: "",
        user_level: "",
      },
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "商品id",
          key: "id",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "封面图片",

          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.goodsimg) ,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },

          // key: "image",
        },
        {
          title: "商品分类",
          key: "goodstype",
        },
        {
          title: "可兑换数量",
          key: "goodsnum",
        },
        {
          title: "已兑换数量",
          key: "outnum",
        },
        {
          title: "兑换所需碎片",
          key: "exintegral",
        },
        {
          title: "兑换所需等级",
          key: "user_level",
        },
        {
          title: "状态",
          key: "nstatus",
          render: (h, params) => {
            const status = params.row.nstatus;
            return h("span", status === 1 ? "在售" : "下架");
          },
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            return h("div", [
              params.row.nstatus === 0 &&
              params.row.outnum != params.row.goodsnum
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.updateMachineStatus(1, params.row.id);
                        },
                      },
                    },
                    "上架"
                  )
                : null,
              params.row.nstatus === 0 &&
              params.row.outnum == params.row.goodsnum
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.updateMachineStatus(1, params.row.id);
                        },
                      },
                    },
                    "重新上架"
                  )
                : null,
              params.row.nstatus === 1
                ? h(
                    "Button",
                    {
                      props: {
                        type: "primary",
                        size: "small",
                      },
                      style: {
                        marginRight: "5px",
                      },
                      on: {
                        click: () => {
                          this.updateMachineStatus(0, params.row.id);
                        },
                      },
                    },
                    "下架"
                  )
                : null,
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      // this.updateMachineStatus(1, params.row.id);
                      this.clickgoodsid = params.row.id + "";
                      this.modal3 = true;
                    },
                  },
                },
                "兑换详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.clickgoodsid = params.row.id;
                      this.selgoodsnum = params.row.goodsnum;
                      this.modal2 = true;
                      // this.updateMachineStatus(1, params.row.id);
                    },
                  },
                },
                "增加数量"
              ),
            ]);
          },
        },
      ],
      selgoodsnum: 0,
      searchId: "",
      searchName: "",
      searchType: "",
      searchStatus: "", // 添加商品状态筛选变量
      current: 1,
      total: 0,
      // 校验规则
      rules: {
        goodsname: [
          { required: true, message: "请输入商品名称", trigger: "blur" },
        ],
        cost: [
          { required: true, message: "请输入商品成本价", trigger: "blur" },
          {
            pattern: /^\d+(\.\d{1,2})?$/,
            message: "成本价最多两位小数",
            trigger: "blur",
          },
        ],
        coinnum: [
          {
            required: true,
            message: "请输入分解成金币的数量",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入分解成金币的数量"));
              } else {
                if (/^[0-9]+$/.test(value)) {
                  callback(); // 验证通过
                } else {
                  callback(new Error("金币数量必须是正整数"));
                }
              }
            },
          },
        ],
       
        goodsimg: [
          { required: true, message: "请上传商品封面图", trigger: "change" },
        ],
        goodstype: [
          { required: true, message: "请选择商品分类", trigger: "change" },
        ],
      },
      // 商品查询相关数据
      goodsSearchModal: false,
      goodsSearchName: "",
      goodsSearchType: "",
      goodsData: [],
      goodsTotal: 0,
      goodsCurrent: 1,
      goodsColumns: [
        {
          title: "商品id",
          key: "id",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "封面图片",
          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.goodsimg) ,
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "商品分类",
          key: "goodstype",
        },
        {
          title: "商品数量",
          key: "goodsnum",
        }, {
          title: "分解币数",
          key: "coinnum",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.selectGoods(params.row);
                    },
                  },
                },
                "选择"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    updateMachineStatus(status, id) {
      updateShopStatus({ nstatus: status, id: id }).then((res) => {
        this.queryGoods();
      });
    },
    // 提交表单数据
    handleSubmit() {
      console.log(this.formData);
      // 表单校验
      this.$refs.formData.validate((valid) => {
        if (valid) {
          this.loading = true;

          const formData = this.formData;
          cmsAddgoods(formData)
            .then((response) => {
              this.loading = false;
              this.modal1 = false; // 表单提交成功后关闭弹窗
              this.$Message.success("商品新增成功！");
              this.queryGoods(); // 刷新商品列表
            })
            .catch((error) => {
              this.loading = false;
              this.$Message.error("商品新增失败！");
              console.error(error);
            });
        } else {
          this.$Message.error("请填写完整的商品信息");
          return false;
        }
      });
    },
    // 取消操作
    cancel() {
      this.modal1 = false;
    },
    // 更新封面图
    updateimage1(imageUrl) {
      this.formData.goodsimg = imageUrl;
    },
    // 更新详情图
    updateimage2(imageUrl) {
      this.formData.goodsimg2 = imageUrl;
    },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsSelShop(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.total; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // 验证输入的是否为正整数
    validatePositiveInteger(value) {
      if (value < 1 || !Number.isInteger(+value)) {
        this.$Message.error("请输入一个正整数");
        this.newGoodsNum = "";
      }
    },
    // 查询商品
    queryGoods() {
      this.current = 1;
      this.fetchGoodsWithParams();
    },

    // 获取查询参数
    getQueryParams() {
      const params = {
        page: this.current,
        pageSize: 10,
      };
      if (this.searchId) {
        params.id = this.searchId;
      }
      if (this.searchName) {
        params.goodsname = this.searchName;
      }
      if (this.searchType) {
        params.goodstype = this.searchType;
      }
      if (this.searchStatus !== "") {
        params.nstatus = this.searchStatus;
      }
      return params;
    },

    // 使用当前参数获取数据
    fetchGoodsWithParams() {
      const params = this.getQueryParams();
      this.fetchGoodsData(params);
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.fetchGoodsWithParams(); // 使用当前查询参数，只更新页码
    },
    // 确认修改商品数量
    submitGoodsNum() {
      if (
        this.newGoodsNum &&
        Number.isInteger(+this.newGoodsNum) &&
        +this.newGoodsNum > 0
      ) {
        cmsUpdateGoodsNum({
          id: this.clickgoodsid,
          beizhu: this.beizhu,
          goodsnum: this.newGoodsNum,
        }) // 更新商品数量 API
          .then((response) => {
            this.$Message.success("商品数量更新成功！");
            this.modal2 = false; // 关闭模态框
            this.queryGoods(); // 刷新查询结果
          })
          .catch((error) => {
            this.$Message.error("商品数量更新失败！");
            console.error(error);
          });
      } else {
        this.$Message.error("请输入有效的商品数量");
      }
    },
    // 取消修改商品数量
    cancelGoodsNum() {
      this.modal2 = false;
    },
    openAddModal() {
      this.isEdit = false; // 设置为新增操作
      this.resetFormData(); // 重置表单
      this.modal1 = true; // 打开弹窗
    },
    resetFormData() {
      // 重置表单数据
      this.formData = {
        goodsid: "",
        goodsnum: "",
        exintegral: "",
        user_level: "",
      };
    },
    guanbimodal() {
      this.modal3 = false;
    },
    // 打开商品查询弹窗
    openGoodsSearchModal() {
      this.goodsSearchModal = true;
      this.goodsSearchName = "";
      this.goodsSearchType = "";
      this.goodsCurrent = 1;
      this.searchProducts();
    },
    // 关闭商品查询弹窗
    closeGoodsSearchModal() {
      this.goodsSearchModal = false;
    },
    // 查询商品列表
    searchProducts() {
      const params = {
        goodsname: this.goodsSearchName || undefined,
        goodstype: this.goodsSearchType || undefined,
        page: this.goodsCurrent,
      };
      
      cmsSelgoods(params)
        .then((response) => {
          this.goodsData = response.data.rows;
          this.goodsTotal = response.data.pagination.total;
          this.goodsCurrent = response.data.pagination.page;
        })
        .catch((error) => {
          this.$Message.error("获取商品列表失败");
          console.error(error);
        });
    },
    // 商品列表分页
    changeGoodsPage(page) {
      this.goodsCurrent = page;
      this.searchProducts();
    },
    // 选择商品
    selectGoods(goods) {
      this.formData.goodsid = goods.id;
      // 使用返回的成本价 * 260 填充商品兑换能量
      if (goods.marketp !== undefined && goods.marketp !== null && goods.marketp !== "") {
        const costNum = Number(goods.marketp);
        if (!isNaN(costNum)) {
          this.formData.exintegral = String(Math.round(costNum * 260));
        }
      }
      this.goodsSearchModal = false;
      this.$Message.success("已选择商品：" + goods.goodsname);
    },
  },
};
</script>
